import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';

import { PRODUCT_INFO } from '@hsc/common/constants/product-info';
import { FAQ_LIST } from '@constants/faq-list';
import { FullStoryService } from '@services/fullstory.service';
import { scrollToSection } from '@utilities/scroll-to-section';

@Component({
  selector: 'hsc-faq',
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <div class="bg-ultralight-gray px-12 py-12.5">
      <div class="bolt-container">
        <div class="mb-6">
          <h2 class="bolt-heading-sm">FAQ</h2>
        </div>
        <bolt-accordion-group class="space-y-4">
          <!--
            splitting the first object out of the loop since the text requires special formatting.  The effort
            to make the loop dynamic enough to handle this case isn't worth it at this time.  We should revisit if this PoC
            expands and we have more FAQs that require special formatting
           -->
          <bolt-accordion
            header="What does the {{ productInfo.name }} cover?"
            class="rounded-md border border-black bg-white"
            [active]="accordion === 0 ? true : null"
            (bolt-accordion-open)="handleFaqOpen(0, 'What does a {{ productInfo.name }} cover?')"
          >
            <p>
              The {{ productInfo.name }} provides repair and replacement coverage for appliances as well as electrical,
              plumbing and HVAC systems. It complements homeowner’s insurance by covering everyday breakdowns caused by
              wear and tear that insurance doesn’t cover. The details of a breakdown situation may impact coverage. See
              <a
                hscFsEventName="Sample Plan FAQ Link Clicked"
                href="#sample-plan"
                (click)="scrollToSection($event, 'sample-plan')"
                >Sample Plan</a
              >
              for full details and exclusions.
            </p>
          </bolt-accordion>
          @for (faq of faqList; track faq.question; let i = $index) {
            <bolt-accordion
              [header]="faq.question"
              class="rounded-md border border-black bg-white"
              [active]="accordion === i + 1 ? true : null"
              (bolt-accordion-open)="handleFaqOpen(i + 1, faq.question)"
            >
              @for (para of faq.answer; track para) {
                <p>{{ para }}</p>
              }
            </bolt-accordion>
          }
        </bolt-accordion-group>
      </div>
    </div>
  `,
})
export class FAQ {
  private readonly fullStoryService = inject(FullStoryService);

  readonly faqList = FAQ_LIST;
  readonly productInfo = PRODUCT_INFO;
  scrollToSection = scrollToSection;
  accordion = -1;

  handleFaqOpen(index: number, question: string) {
    this.accordion = index;
    this.fullStoryService.event('FAQ Opened', {
      faqIndex: index + 1,
      faqQuestion: question,
    });
  }
}
